// hooks/useSearchTracking.ts
import { useEffect, useRef } from "react";
import { logEvent } from "@shared/analytics/analytics";

interface UseSearchTrackingProps {
  searchTerm: string;
  eventName?: string;
  additionalProps?: Record<string, any>;
  minLength?: number;
}

export const useSearchTracking = ({
  searchTerm,
  eventName = "Search Performed",
  additionalProps = {},
  minLength = 0,
}: UseSearchTrackingProps) => {
  const lastTrackedTerm = useRef<string | null>(null);
 
  useEffect(() => {
    const trimmedTerm = searchTerm.trim();

    if (
      trimmedTerm.length >= minLength &&
      lastTrackedTerm.current !== trimmedTerm
    ) {
      lastTrackedTerm.current = trimmedTerm;
        console.log('debug triggered')
      logEvent(eventName, {
        searchTerm: trimmedTerm,
        ...additionalProps,
      });
    }
  }, [searchTerm, eventName, additionalProps, minLength]);
};
